import { TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import type { TextFieldProps } from '@mui/material/TextField'

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  '& .MuiInputBase-root': {
    fontSize: '1rem',
    color: theme.palette.text.primary,
  },
  '& .MuiInputBase-input': {
    padding: 0,
  },
  '& .MuiInput-underline:before': {
    display: 'none',
  },
  '& .MuiInput-underline:after': {
    display: 'none',
  },
}))

export const BaseTextField: React.FC<TextFieldProps> = (props) => {
  return (
    <StyledTextField
      variant="standard"
      fullWidth
      {...props}
      slotProps={{
        input: {
          disableUnderline: true,
        },
        ...props.slotProps,
      }}
    />
  )
}

export default BaseTextField
